import type { EditLinksSlice, EditLinksState, ViewerSliceCreator } from "./types";

export const editLinksInitialState: EditLinksState = {
  editLinksMode: false,
  editLinksInstanceId: null,
  editLinksModuleId: null,
  editLinksData: [],
  editLinksCanBeChild: true,
  editLinksHasServo: true,
  editLinksEndEffectorMode: "auto",
  editLinksEndEffectorLink: null,
  editLinksEndEffectorOffsetXyz: [0, 0, 0],
  editLinksEndEffectorOffsetRpy: [0, 0, 0],
  editLinksCanEditEndEffector: true,
};

export const createEditLinksSlice: ViewerSliceCreator<EditLinksSlice> = (set) => ({
  ...editLinksInitialState,

  setModuleLinks: (msg) =>
    set((state) => {
      if (msg.links.length > 0) {
        state.editLinksMode = true;
        state.editLinksInstanceId = msg.instance_id;
        state.editLinksModuleId = msg.module_id;
        state.editLinksData = msg.links;
        state.editLinksCanBeChild = msg.can_be_child ?? true;
        state.editLinksHasServo = msg.has_servo ?? true;
        const mode = msg.end_effector_mode ?? (msg.end_effector_link ? "custom" : "auto");
        state.editLinksEndEffectorMode = mode;
        state.editLinksEndEffectorLink = mode === "custom" ? (msg.end_effector_link ?? null) : null;
        state.editLinksEndEffectorOffsetXyz = msg.end_effector_offset_xyz ?? [0, 0, 0];
        state.editLinksEndEffectorOffsetRpy = msg.end_effector_offset_rpy ?? [0, 0, 0];
        state.editLinksCanEditEndEffector = msg.can_edit_end_effector ?? true;
      } else {
        state.editLinksMode = false;
        state.editLinksInstanceId = null;
        state.editLinksModuleId = null;
        state.editLinksData = [];
        state.editLinksCanBeChild = true;
        state.editLinksHasServo = true;
        state.editLinksEndEffectorMode = "auto";
        state.editLinksEndEffectorLink = null;
        state.editLinksEndEffectorOffsetXyz = [0, 0, 0];
        state.editLinksEndEffectorOffsetRpy = [0, 0, 0];
        state.editLinksCanEditEndEffector = true;
      }
    }),

  toggleLinkConnectable: (linkName) =>
    set((state) => {
      const link = state.editLinksData.find(l => l.name === linkName);
      if (link) {
        link.is_connectable = !link.is_connectable;
      }
    }),

  setEditLinksCanBeChild: (canBeChild: boolean) =>
    set((state) => {
      state.editLinksCanBeChild = canBeChild;
    }),

  setEditLinksHasServo: (hasServo: boolean) =>
    set((state) => {
      state.editLinksHasServo = hasServo;
    }),

  setEditLinksEndEffectorMode: (mode: "auto" | "none" | "custom") =>
    set((state) => {
      state.editLinksEndEffectorMode = mode;
      if (mode !== "custom") {
        state.editLinksEndEffectorLink = null;
      }
    }),

  setEditLinksEndEffectorLink: (linkName: string | null) =>
    set((state) => {
      state.editLinksEndEffectorLink = linkName;
      if (linkName) {
        state.editLinksEndEffectorMode = "custom";
      }
    }),

  setEditLinksEndEffectorOffsetXyz: (xyz: [number, number, number]) =>
    set((state) => {
      state.editLinksEndEffectorOffsetXyz = xyz;
    }),

  setEditLinksEndEffectorOffsetRpy: (rpy: [number, number, number]) =>
    set((state) => {
      state.editLinksEndEffectorOffsetRpy = rpy;
    }),

  exitEditLinksMode: () =>
    set((state) => {
      state.editLinksMode = false;
      state.editLinksInstanceId = null;
      state.editLinksModuleId = null;
      state.editLinksData = [];
      state.editLinksCanBeChild = true;
      state.editLinksHasServo = true;
      state.editLinksEndEffectorMode = "auto";
      state.editLinksEndEffectorLink = null;
      state.editLinksEndEffectorOffsetXyz = [0, 0, 0];
      state.editLinksEndEffectorOffsetRpy = [0, 0, 0];
      state.editLinksCanEditEndEffector = true;
    }),
});
